import axios from "@common/api/desktop/axios";

export const fetchSession = async (id, showGamePlayEvents = false) => {
  const response = await axios.get(
    `Sessions/Details2/${id},${showGamePlayEvents}`,
  );
  return response.data;
};
